export default "__VITE_ASSET__22c17507__"